/**
 * @generated SignedSource<<d73aa17a6fdbe1d6ca4423feacaa4956>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type settingsHolidayCalendars_HolidayCalendar$data = {
  readonly id: string;
  readonly name: string | null;
  readonly holidayCalendarEntries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly year: number | null;
        readonly month: number | null;
        readonly day: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "settingsHolidayCalendars_HolidayCalendar";
};
export type settingsHolidayCalendars_HolidayCalendar$key = {
  readonly " $data"?: settingsHolidayCalendars_HolidayCalendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"settingsHolidayCalendars_HolidayCalendar">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "holidayCalendarEntries"
        ]
      }
    ]
  },
  "name": "settingsHolidayCalendars_HolidayCalendar",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": "holidayCalendarEntries",
      "args": null,
      "concreteType": "HolidayCalendarEntryTypeConnection",
      "kind": "LinkedField",
      "name": "__HolidayCalendar_holidayCalendarEntries_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HolidayCalendarEntryTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HolidayCalendarEntry",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "year",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "month",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "day",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HolidayCalendar",
  "abstractKey": null
};
})();

(node as any).hash = "7d6c7d7341203ab4890e1c82dfde6f51";

export default node;
